// ANCHOR Models
import { CourseCardData } from '@lyon/scoped-models/CourseCardData';
import { ProviderCheckManager } from '@lyon/scoped-models/ProviderCheckManager';

// ANCHOR Results
import { PublishStatus } from '@lyon/utils/api/results/course';

// ANCHOR Components
import { ImageBadge } from '@lyon/components/utils/ImageBadge';
import { BadgeColor } from '@lyon/components/utils/ImageBadge/styles';
import { constant } from '@lyon/components/utils/constant';

export const LyonCourseCardPublished = constant(() => {
  const publishStatus = CourseCardData.useSelector((state) => state.data?.publishStatus);
  const isProvider = ProviderCheckManager.useSelector((state) => state.data);

  if (isProvider && publishStatus) {
    return (
      <ImageBadge color={publishStatus === 'draft'
        ? BadgeColor.white
        : BadgeColor.inversePrimary}
      >
        {{
          [PublishStatus.DRAFT]: 'draft',
          [PublishStatus.PUBLISHED]: 'public',
          [PublishStatus.CLOSED]: 'invite-only',
          [PublishStatus.UNLISTED]: 'unlisted',
        }[publishStatus]}
      </ImageBadge>
    );
  }

  return null;
});
